import React from 'react';
import SingleOrderItem from './singleOrderItem';
import _ from 'lodash';
import styles from './index.module.scss';
import { IExternalOrder } from 'interfaces/externalOrder';
import ActionButton from 'components/ActionButton';

const OrderItems: React.FC<IExternalOrder.IExternalOrderItemsProps> = props => {
  const { items, setItems, disabled, setRequoteOrderFlag,userId } = props;

  const deleteItem = (index: number) => {
    const itemsCopy = _.cloneDeep(items);
    if (itemsCopy.length > 1) {
      itemsCopy.splice(index, 1);
    } else {
      itemsCopy.splice(index, 1, {
        id: '',
        name: '',
        price: 0,
        quantity: 0,
        discountPercent: '',
        fixedDiscountAmount: '',
      });
    }
    setItems(itemsCopy);
    setRequoteOrderFlag();
  };

  const addItem = () => {
    const itemsCopy = _.cloneDeep(items);
    itemsCopy.push({
      id: '',
      name: '',
      quantity: 0,
      price: 0,
      discountPercent: '',
      fixedDiscountAmount: '',
    });
    setItems(itemsCopy);
  };

  const setItem = (item: IExternalOrder.IExternalOrderItemType, index: number) => {
    const itemsCopy = _.cloneDeep(items);
    itemsCopy[index] = item;
    setItems(itemsCopy);
    setRequoteOrderFlag();
  };

  return (
    <div className={styles['items-main-container']}>
      <div className={styles['section-header']}>
        <div className={styles['section-heading']}>Inventory Items</div>
      </div>
      <div className={styles['items-container']}>
        {items.map((item, i) => (
          <SingleOrderItem
            key={i}
            index={i}
            item={item} 
            userId={userId}
            setItem={setItem}
            disabled={disabled}
            deleteItem={deleteItem}
          />
        ))}
      </div>
      <div className={styles['button-container']}>
        <ActionButton
          text={<>Entry<span>+</span></>}
          active={!disabled}
          isLoading={disabled}
          onClick={addItem}
        />
      </div>
    </div>
  );
};

export default OrderItems;
